import type { FaireProductEntity } from "../../entity_types/product";

export const p_kept6a4w8x: FaireProductEntity = {
  token: "p_kept6a4w8x",
  type: "product",
  name: "Butch Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/70b2835575580d2b83758e72de66a033b99fb9b18a5a523ce6e8610ab0b041dc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ea7aa4fe9602845ca99ee45810731ad92bbd58bf92df47b4b30369859fe87781.jpeg",
    "https://cdn.faire.com/fastly/dae1a31db1eae893ea9a0e0c6109a43c17651444252f4e7f3f761a54f8ac5608.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/038495d5b6a845fda43bfcbe182cdfdbd61a6b4b8562d8f59c4fa30d12ae63f7.jpeg",
    "https://cdn.faire.com/fastly/891b63c7b19e1d35a70f6dd48a07edda87c2eab001245c96e76889c323fe91c1.jpeg"
  ],
  priceDollars: 6.75,
  description: "Built a little tough, but soft where it counts—these socks know that being Butch is all about balance.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products—be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:08.725Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
